import omit from 'lodash/omit';
import { deepKeysToCamel } from '@eb/transformation-utils';

const _formatCollectionEntity = ({ followStatus = {}, ...collection }) => ({
    isFollowing: followStatus.followedByYou,
    ...omit(collection, 'image'),
});

export const getInitialState = ({
    facebookOptions,
    events,
    shareUrl,
    secret,
    featureFlags,
    collectionCreatorImageOverrideUrl,
    collection: collectionEntity,
    user: { publicId, isAuthenticated },
    isGDPRCountry,
    env: {
        isMobile,
        serverUrl,
        currencyFormat,
        ebDomain: domain,
        localeInfo: {
            twitter_handle: twitterHandle,
            facebook_locale: facebookLocale,
            facebook_page: facebookPage,
        },
    },
    gaSettings,
}) => {
    // We have both image and image_large, take out
    // image since we're not using it to avoid confusion
    const formattedCollectionEntity = _formatCollectionEntity(
        deepKeysToCamel(collectionEntity),
    );

    return {
        collection: {
            secret,
            shareUrl,
            displayCreatorImageUrl: collectionCreatorImageOverrideUrl,
            ...formattedCollectionEntity,
        },
        events,
        domain,
        currencyFormat,
        featureFlags,
        userId: publicId,
        isGDPRCountry,
        shareOptions: {
            isMobile,
            twitterHandle,
            serverUrl,
            facebookOptions: {
                ...facebookOptions,
                locale: facebookLocale,
                page: facebookPage,
            },
        },
        gaSettings,
        isAuthenticated,
    };
};
